/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DateTimeRestrictionValidationData,
    DateTimeRestrictionValidationDataFromJSON,
    DateTimeRestrictionValidationDataFromJSONTyped,
    DateTimeRestrictionValidationDataToJSON,
    ListItemValidationMessage,
    ListItemValidationMessageFromJSON,
    ListItemValidationMessageFromJSONTyped,
    ListItemValidationMessageToJSON,
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface SMRuleFormValidationData
 */
export interface SMRuleFormValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SMRuleFormValidationData
     */
    description?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SMRuleFormValidationData
     */
    maxPriceSolutions?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SMRuleFormValidationData
     */
    maxPricePoints?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SMRuleFormValidationData
     */
    dateTimeRestrictionsTimeZone?: ValidationMessage;
    /**
     * 
     * @type {Array<DateTimeRestrictionValidationData>}
     * @memberof SMRuleFormValidationData
     */
    readonly dateTimeRestrictions?: Array<DateTimeRestrictionValidationData> | null;
    /**
     * 
     * @type {Array<ListItemValidationMessage>}
     * @memberof SMRuleFormValidationData
     */
    readonly travelDates?: Array<ListItemValidationMessage> | null;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SMRuleFormValidationData
     */
    brandAndMarket?: ValidationMessage;
}

export function SMRuleFormValidationDataFromJSON(json: any): SMRuleFormValidationData {
    return SMRuleFormValidationDataFromJSONTyped(json, false);
}

export function SMRuleFormValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SMRuleFormValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : ValidationMessageFromJSON(json['description']),
        'maxPriceSolutions': !exists(json, 'maxPriceSolutions') ? undefined : ValidationMessageFromJSON(json['maxPriceSolutions']),
        'maxPricePoints': !exists(json, 'maxPricePoints') ? undefined : ValidationMessageFromJSON(json['maxPricePoints']),
        'dateTimeRestrictionsTimeZone': !exists(json, 'dateTimeRestrictionsTimeZone') ? undefined : ValidationMessageFromJSON(json['dateTimeRestrictionsTimeZone']),
        'dateTimeRestrictions': !exists(json, 'dateTimeRestrictions') ? undefined : (json['dateTimeRestrictions'] === null ? null : (json['dateTimeRestrictions'] as Array<any>).map(DateTimeRestrictionValidationDataFromJSON)),
        'travelDates': !exists(json, 'travelDates') ? undefined : (json['travelDates'] === null ? null : (json['travelDates'] as Array<any>).map(ListItemValidationMessageFromJSON)),
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : ValidationMessageFromJSON(json['brandAndMarket']),
    };
}

export function SMRuleFormValidationDataToJSON(value?: SMRuleFormValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': ValidationMessageToJSON(value.description),
        'maxPriceSolutions': ValidationMessageToJSON(value.maxPriceSolutions),
        'maxPricePoints': ValidationMessageToJSON(value.maxPricePoints),
        'dateTimeRestrictionsTimeZone': ValidationMessageToJSON(value.dateTimeRestrictionsTimeZone),
        'brandAndMarket': ValidationMessageToJSON(value.brandAndMarket),
    };
}


